import type { IconSvgObject } from './types';

const SwipeUp04Icon: IconSvgObject = [
  ["path", { d: "M17.5 2L15 4.5M17.5 2L20 4.5M17.5 2L17.5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 15L7 11M7 11L7 4.75C7 3.7835 7.7835 3 8.75 3C9.7165 3 10.5 3.7835 10.5 4.75L10.5 11H15C16.6569 11 18 12.3431 18 14V19C18 20.6569 16.6569 22 15 22H8.5841C7.90785 22 7.27739 21.6583 6.90829 21.0916L4.98731 18.1426C4.11571 16.8152 4.01657 16.2011 4.00083 15.5302C3.99373 15.2276 4.03246 14.9256 4.11571 14.6346C4.30031 13.9894 4.77679 13.4448 5.7297 12.3558L7 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SwipeUp04Icon;
